module.exports = __webpack_public_path__ + "static/media/logo_azul.9ce10c76.png";